




























import Vue from 'vue';
import { find, difference } from 'lodash';

import { ZenObjectTable } from 'zenComponents';
import LoadingSpinner from '@reciprocity/loading-spinner';
import { createFetcherTask, loadFetchers, loadFetcherTask } from '@/utils/crudActions';
import { Fetcher, FetcherTask } from './types';
import FetcherAction from './FetcherAction.vue';

const getFetcherById = (fetcherId: number, fetchers: Fetcher[]): Fetcher | void => {
  return find(fetchers, { id: fetcherId });
};

export default Vue.extend({
  name: 'FetchersTab',
  components: {
    FetcherAction,
    LoadingSpinner,
    ZenObjectTable,
  },
  props: {
    csrfToken: {
      type: String,
      required: true,
    },
    objectId: {
      type: String,
      required: true,
    },
    objectType: {
      type: String,
      required: true,
    },
    updateInterval: {
      type: Number,
      default: 1000,
    },
  },
  data() {
    return {
      isLoadingInfo: true,
      info: [] as Fetcher[],
      tasks: [] as FetcherTask[],
      tableColumns: ['name', 'integration', 'description', 'action'],
      isUpdating: false,
    };
  },
  created() {
    this.loadInfo();
  },
  methods: {
    getTaskByFetcherId(fetcherId: number) {
      return find(this.tasks, { fetcherId });
    },
    async loadInfo(): Promise<void> {
      this.isLoadingInfo = true;

      try {
        this.info = (await this.loadFetchersInfo(this.objectType, this.objectId)) as Fetcher[];
      } catch (error) {
        this.showError(error);
      } finally {
        this.isLoadingInfo = false;
      }
    },
    async fetch(fetcherId: number): Promise<void> {
      const fetcher: Fetcher = getFetcherById(fetcherId, this.info);
      if (window.analytics && fetcher) {
        analytics.track('Evidence Requested', {
          name: fetcher.name,
          connector: fetcher.integration,
        });
      }

      try {
        const newTask = (await this.createFetcherTask({
          csrfToken: this.csrfToken,
          objectType: this.objectType,
          objectId: Number(this.objectId),
          fetcherId,
        })) as FetcherTask;

        this.tasks.push(newTask);
        if (this.isUpdating === false) {
          window.setTimeout(this.updateTasks, this.updateInterval);
        }
      } catch (error) {
        this.showError();
      }
    },
    async updateTasks() {
      this.isUpdating = true;
      const tasksInProgress = this.tasks.filter(this.taskInProgress);

      try {
        const updatedTasks = (await Promise.all(
          tasksInProgress.map(task => this.loadFetcherTask(task.self))
        )) as FetcherTask[];

        const tasksDone = difference(this.tasks, tasksInProgress);
        this.tasks = tasksDone.concat(updatedTasks);
      } catch (error) {
        this.showError();
      } finally {
        const allDone = this.tasks.filter(this.taskInProgress).length === 0;

        if (allDone) {
          this.isUpdating = false;
        } else {
          window.setTimeout(this.updateTasks, this.updateInterval);
        }
      }
    },
    showError() {
      window.GGRC.Notify({
        type: 'error',
        message: 'Oops, something went wrong.',
      });
    },
    taskInProgress(task: FetcherTask) {
      return ['CREATING', 'FETCHING'].includes(task.state);
    },
    createFetcherTask,
    loadFetcherTask,
    loadFetchersInfo: loadFetchers,
  },
});
